import React from "react";
import {Navbar, Container} from "react-bootstrap";
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";
import { NavLink, useLocation } from "react-router-dom";
import { mauiRoutes } from "../../routes.js";
import { useTranslation } from "react-i18next";

const MenuIcons = props => {
    const {isAdmin, adminIcon, helpIcon, translate} = props;
    return (
        <div
            className="NavBar-btn-container knoa-region d-flex align-items-center gap-2"
            tabIndex="-1"
        >
            {isAdmin && (
                <NavLink
                    to={{ pathname: "/admin/AllSettings" }}
                    className="nav-link-topbar-setting"
                    activeClassName="active"
                    title={translate("common:settings")}
                >
                    <i className={`${adminIcon} navbar-icon`} />
                </NavLink>
            )}
            <a
                aria-current="page"
                className="nav-link-topbar-help"
                href="http://knoabi.helpdocsonline.com/home"
                title={translate("common:help")}
                target="_blank"
            >
                <i className={`${helpIcon} navbar-icon`} />
            </a>
        </div>
    )
};

function AdminNavbar({ navVarBrand, navMenuOptions, isAdmin, adminIcon, helpIcon, getActiveRoute }) {
    const location = useLocation();
    const { t } = useTranslation();

    const getNavbarMenuOptions = () => {
        const pageName = location.pathname.split("/").pop();
        if (pageName === "home") {
            return [{ name: t("common:customize"), icon: "pe-7s-tools", href: "myPreference" }];
        }
        if (pageName === "viewProject" && navMenuOptions?.length) {
            return navMenuOptions.map((item, index) => ({
                ...item,
                name: index === 0 ? t("route.name:Edit Project") : t("dialog:shareProject"),
                href: index === 0 ? "editProject" : ""
            }));
        }
        return [];
    };

    const menuOptions = getNavbarMenuOptions();
    const routes = mauiRoutes.getRoutes();

    return (
        <Navbar className="navbar-fixed">
            <Container fluid>
                <Navbar.Brand>
                    {navVarBrand || getActiveRoute(routes, t)}
                </Navbar.Brand>

                <Navbar.Toggle />

                <Navbar.Collapse>
                    <div className="d-flex w-100 justify-content-end align-items-center gap-2">
                        <AdminNavbarLinks navbarMenuOptions={menuOptions} />
                        <MenuIcons isAdmin={isAdmin} adminIcon={adminIcon} helpIcon={helpIcon} translate={t} />
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default AdminNavbar;